import { render } from "./slidebar.vue?vue&type=template&id=1e781eb0"
import script from "./slidebar.vue?vue&type=script&lang=js"
export * from "./slidebar.vue?vue&type=script&lang=js"

import "./slidebar.vue?vue&type=style&index=0&id=1e781eb0&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__